let colorStr = "#77b6ec,#77b6ec,#77b6ec,#77b6ec,#77b6ec,#77b6ec,#77b6ec,#73b2e8,#70aee3,#6ca9df,#68a5db,#64a1d7,#619dd2,#5d99ce,#5995ca,#5590c6,#528cc1,#4e88bd,#4a84b9,#4780b4,#437bb0,#3f77ac,#3b73a8,#386fa3,#346b9f,#30679b,#2c6297,#295e92,#255a8e";
export let colors = colorStr.split(",");
